module.exports = __webpack_public_path__ + "img/宋志红.4aeb6485.jpg";